// extracted by mini-css-extract-plugin
module.exports = {"pageLinks":"pagination-module--pageLinks--2KH7L"};